@let a = attachment();
<button
  type="button"
  class="tf-attachment-chip"
  [class.tf-attachment-chip--deleted]="a.isDeleted"
  [disabled]="a.isDeleted"
  [attr.aria-label]="
    a.isDeleted
      ? ('COMMENTS.ATTACHMENT.UNAVAILABLE_ARIA' | translate: { name: a.name })
      : ('COMMENTS.ATTACHMENT.OPEN_ARIA' | translate: { name: a.name })
  "
  (click)="onClick()">
  <i class="tf-attachment-chip__icon" [class]="iconClass()" aria-hidden="true"></i>
  <span class="tf-attachment-chip__name" [title]="a.name">{{ a.name }}</span>
  @if (a.isDeleted) {
    <span class="tf-attachment-chip__size tf-attachment-chip__size--deleted">
      {{ 'COMMENTS.ATTACHMENT.UNAVAILABLE' | translate }}
    </span>
  } @else {
    <span class="tf-attachment-chip__size">{{ a.sizeBytes | tfFormatBytes }}</span>
  }
</button>
